import {
    openOrderStatusLayerAction,
    closePostcodeLayerAction,
    closeProductLayerAction,
    closeOrderStatusLayerAction,
    closeOrderFormLayerAction,
    setOrderAction, unsetOrderAction,
    setErrorMessageAction, unsetErrorMessageAction,
    unsetPaymentStatus
} from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import BillingAddressStore from '../../_flux/stores/billing_address_store';
import ProductMixedStocksStore from '../../_flux/stores/product_mixed_stocks_lightbox_store';
import {showAction as lockUi, hideAction as unlockUi} from '../../_flux/actions/ui_lock_actions';
import mixedStocksPlaceOrderRequest  from '../../_flux/components/product/product_mixed_stocks_place_order_request';
import {validateBillingAddress} from './address_validation';

export default function onPlaceOrderClick() {
    return () => {
        unsetPaymentStatus();
        unsetOrderAction();
        unsetErrorMessageAction();
        const {cart, fittingOptions, fittingServices} = ProductMixedStocksStore.getState();
        const {address, invalid} = BillingAddressStore.getState();
        validateBillingAddress(address);
        if (invalid.length > 0) {
            return;
        }

        lockUi();
        mixedStocksPlaceOrderRequest(cart, fittingOptions, fittingServices, address)
            .then((result) => {
                setOrderAction(result);
                closePostcodeLayerAction();
                closeProductLayerAction();
                closeOrderStatusLayerAction();
                closeOrderFormLayerAction();
                openOrderStatusLayerAction();
                unlockUi();
            })
            .catch((result) => {
                let errorMessage = 'product-mixed-stocks-place-order-loading-failed';
                if (typeof result.responseJSON !== 'undefined') {
                    const resultJson = result.responseJSON;
                    if (typeof resultJson.type !== 'undefined' && typeof resultJson.message !== 'undefined' && 'validation_error' === resultJson.type) {
                        errorMessage = resultJson.message;
                    }
                }

                setErrorMessageAction(errorMessage);
                unlockUi();
            });
    };
}
